import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { EnjoyedYear } from '@app/entities/models/ptrab/irs/enjoyed-year.model';
import {
  Dependant,
  IrsModel,
  IrsWithholdingModel,
  Spouse,
  WorkerPt,
  YoungBenefit
} from '@app/entities/models/ptrab/irs/irs.model';

export interface IrsRepository {
  getData(): Observable<IrsModel>;
  modifyIrsPersonalData(worker: WorkerPt, authorization: TwoFactorAuthorization): Observable<IrsModel>;
  modifyIrsSpouse(spouse: Spouse, authorization: TwoFactorAuthorization): Observable<IrsModel>;
  modifyIrsDependent(dependant: Dependant, authorization: TwoFactorAuthorization): Observable<IrsModel>;
  deleteIrsDependent(id: number): Observable<IrsModel>;
  modifyIrsYoungBenefit(youngBenefit: YoungBenefit, authorization: TwoFactorAuthorization): Observable<IrsModel>;
  deleteIrsYoungBenefit(): Observable<IrsModel>;
  getWithholding(): Observable<IrsWithholdingModel>;
  modifyIrsWithholding(
    withholding: IrsWithholdingModel,
    authorization: TwoFactorAuthorization
  ): Observable<IrsWithholdingModel>;
  deleteIrsWithholding(): Observable<IrsWithholdingModel>;
  getEnjoyedYears(): Observable<EnjoyedYear[]>;
  getError(): void;
  getErrorMsg(): void;
}

export const IRS_REPOSITORY = new InjectionToken<IrsRepository>('IRS_REPOSITORY');
